import { MemberTransactionType } from '@types';

export const isTransactionDisableEligible = (
  row: MemberTransactionType,
  canDisable: boolean,
  isRestrictDisablePaymentOrderEnabled: boolean,
  isOwnerOrOrgAdmin: boolean
): boolean =>
  row?.status === 'processing' &&
  row.total_paid_amount === '0' &&
  !row.is_auto_debit_in_progress &&
  canDisable &&
  (!isRestrictDisablePaymentOrderEnabled || isOwnerOrOrgAdmin);

export const getDisabledRowTooltips = (
  transactions: MemberTransactionType[]
): Record<string, string> => {
  const tooltips: Record<string, string> = {};
  transactions?.forEach((row) => {
    if (row.status !== 'disabled') return;
    const text = row.disabled_reason?.trim();
    if (text) tooltips[row.id] = `Disable remark: ${text}`;
  });
  return tooltips;
};
